.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 64px;
  padding: 10px 18px;
  border: var(--border) solid var(--line);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  font-family: var(--font-body);
  font-weight: 800;
  font-size: 1.3rem;
  line-height: 1.1;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  background: var(--paper);
  color: var(--ink);
  transition:
    transform 0.08s ease,
    box-shadow 0.08s ease;
}

.block {
  display: flex;
  width: 100%;
}

.button:active:not(:disabled) {
  transform: translateY(4px);
  box-shadow: 0 2px 0 var(--line);
}

.button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.button svg {
  flex: none;
}

.label {
  min-width: 0;
}

.lg {
  min-height: 84px;
  font-size: 1.6rem;
}

.md {
  min-height: 64px;
  font-size: 1.3rem;
}

.sm {
  min-height: 48px;
  padding: 6px 14px;
  font-size: 1.05rem;
  border-width: var(--border-sm);
  border-radius: var(--radius-sm);
  box-shadow: var(--shadow-sm);
}

.go {
  background: var(--go);
  color: var(--on-go);
}

.stop {
  background: var(--stop);
  color: var(--on-stop);
}

.light {
  background: var(--paper);
  color: var(--ink);
}

.sun {
  background: var(--sun);
  color: #2b1f3d;
}

.danger {
  background: var(--paper);
  color: var(--stop);
  border-color: var(--stop);
  box-shadow: 0 6px 0 var(--stop);
}

:root[data-theme='dark'] .danger {
  color: var(--danger-soft);
  border-color: var(--danger-soft);
  box-shadow: 0 6px 0 var(--danger-soft);
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme='light']) .danger {
    color: var(--danger-soft);
    border-color: var(--danger-soft);
    box-shadow: 0 6px 0 var(--danger-soft);
  }
}
